module.exports = __webpack_public_path__ + "media/assets/open-book-86f5e96d5cf28136ee01a5fe0c5e7bdc.svg";